import React from 'react';

export function Kenya(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="#006600"/>
      <path d="M0 97H513V148H0V97Z" fill="white"/>
      <path d="M0 114H513V228H0V114Z" fill="#BB0000"/>
      <path d="M0 194H513V245H0V194Z" fill="white"/>
      <path d="M0 228H513V342H0V228Z" fill="#006600"/>
      <path d="M230,110 L256,60 L282,110 L282,232 L256,282 L230,232Z" fill="#1E1E1E"/>
      <path d="M230,110 L282,110 L282,232 L230,232Z" fill="#BB0000"/>
      <ellipse cx="256" cy="171" rx="22" ry="35" fill="white" stroke="#BB0000" strokeWidth="3"/>
    </svg>
  );
}
